module.exports = __webpack_public_path__ + "media/images/lp_graduation-3-fbd4a215c773f2cdc2b3974f5ece30b7.webp";